import Slider from "react-slick";
import { useContext, useEffect, useState, Fragment } from "react";
import { isEmpty } from "lodash";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  FormGroup,
  InputGroup,
  Modal,
  ModalBody,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "./../../../components/Icon/Icon";
import EmptyData from "./../../../helpers/EmptyData/EmptyData";
import OLMap from "../../../helpers/OLMap/OLMap";
import ErrorMessage from "../../../helpers/ErrorMessage/ErrorMessage";
import RangeDateTimePicker from "../../../components/RangeDateTimePicker/RangeDateTimePicker";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { Block } from "../../../components/Block/Block";
import { Col, Row } from "./../../../components/Grid/Grid";
import { productSliderOptions } from "../../../utils";
import { receptionInfoUserContext } from "../../../context/UserContext/ReceptionInfoUserContext/ReceptionInfoUserContext";
import { base_url } from "../../../services/configServices/config";
import {
  createReceptionOrderValidation,
  createTravelReceptionOrderValidation,
} from "../../../utils/validation/validation";
import {
  areYouSureMessage,
  toastErrorMessage,
} from "../../../utils/toastMessage/toastMessage";
import { categoryItems } from "../../../utils/enum";

const ReceptionInfoUser = () => {
  const user = useSelector((state) => state.user);

  const { receptionInfo, products, handleGetReceptionInfo, handleCreateOrder } =
    useContext(receptionInfoUserContext);

  const [currentSlide, setCurrentSlide] = useState({});
  const [isShowDesc, setIsShowDesc] = useState(false);
  const [isShowFeatures, setIsShowFeatures] = useState(false);
  const [isShowAddress, setIsShowAddress] = useState(false);
  const [, setReduce] = useState(0);

  useEffect(() => {
    if (!isEmpty(receptionInfo.pictures))
      setCurrentSlide(receptionInfo.pictures[0]);
  }, [receptionInfo.pictures]);
  useEffect(() => {
    handleGetReceptionInfo();
  }, []);

  // Changes slides
  const slideChange = (index) => {
    var picture = receptionInfo?.pictures?.find(
      (_, _index) => _index === index
    );
    setCurrentSlide(picture);
  };

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      receptionInfo.type === categoryItems[0]
        ? createTravelReceptionOrderValidation
        : createReceptionOrderValidation
    ),
  });

  const handleAddItem = (type) => {
    const initialGuest = {
      first_name: "",
      foreigner: false,
      last_name: "",
    };

    switch (type) {
      case "guests":
        const finalGuests = [...(watch(type) ?? []), initialGuest];
        if (
          receptionInfo.isCheckNumberOfCovered &&
          user.numberOfCovered < finalGuests.length
        )
          return toastErrorMessage(
            `تعداد افراد تحت پوشش شما ${user.numberOfCovered} نفر است`
          );
        setValue(type, finalGuests);
        break;

      default:
        break;
    }
  };
  const handleRemoveItem = (type, index) =>
    setValue(
      type,
      watch(type)?.filter((_, _i) => _i !== index)
    );

  if (isEmpty(receptionInfo)) return <EmptyData />;

  return (
    <>
      <SiteTitle title={`اطلاعات پذیرنده ${receptionInfo?.title}`} />

      <Block>
        <Card className="card-bordered">
          <CardBody>
            <Row>
              <Col xxl={6}>
                <div className="product-gallery mr-xl-1 mr-xxl-5">
                  <div className="border p-1 rounded">
                    <img
                      src={base_url + currentSlide}
                      className="w-100"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <Slider afterChange={slideChange} {...productSliderOptions}>
                    {receptionInfo?.pictures?.map((item) => (
                      <div
                        className={`slider-item ${
                          currentSlide === item ? "slick-current" : ""
                        }`}
                        key={item}
                      >
                        <div className="thumb">
                          <img
                            src={base_url + item}
                            alt=""
                            loading="lazy"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="mt-5 justify-content-center">
                  <h2 className="product-title">{receptionInfo?.title}</h2>
                </div>
              </Col>
              <Col xxl={6}>
                <div className="product-info mr-xxl-5">
                  {receptionInfo.description && (
                    <>
                      <div
                        className="product-excrept text-soft cursor-pointer"
                        onClick={() => setIsShowDesc(!isShowDesc)}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h6>درباره پذیرنده</h6>
                          <span>
                            <p className="text-center font-weight-bold text-dark">
                              {isShowDesc ? "بستن" : "+ مشاهده کامل"}
                            </p>
                          </span>
                        </div>
                        <p
                          className="lead text-justify"
                          style={{
                            height: isShowDesc ? "auto" : 70,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {receptionInfo.description}
                        </p>
                      </div>
                      <hr className="hr border-light" />
                    </>
                  )}
                  <div
                    className="product-meta cursor-pointer"
                    onClick={() => setIsShowFeatures(!isShowFeatures)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>امکانات</h6>
                      <span>
                        <p className="text-center font-weight-bold text-dark">
                          {isShowFeatures ? "بستن" : "+ امکانات بیشتر"}
                        </p>
                      </span>
                    </div>
                    <ul className="row">
                      {receptionInfo?.features
                        ?.filter((_, index) =>
                          isShowFeatures ? index >= 0 : index < 8
                        )
                        ?.map((item, index) => (
                          <li
                            key={index}
                            className="col-6 col-sm-4 col-md-3 my-1"
                          >
                            <div className="fs-14px fw-bold text-muted">
                              {item}
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                  <hr className="hr border-light" />
                  <div
                    className="product-meta cursor-pointer"
                    onClick={() => setIsShowAddress(true)}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <h6>آدرس پذیرنده</h6>
                      <span>
                        <p className="text-center font-weight-bold text-dark">
                          + جزئیات بیشتر
                        </p>
                      </span>
                    </div>

                    <div className="d-flex align-items-center">
                      <img src="/assets/images/icons/map_bg.jpg" alt="" />
                      <p className="fs-14px fw-bold text-muted ml-3">
                        {receptionInfo.address}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Block>
      <hr className="hr border-light" />
      <Block>
        {isEmpty(products) ? (
          <EmptyData title="محصولی برای نمایش یافت نشد" />
        ) : (
          <>
            {products?.map((item) => (
              <Fragment key={item._id}>
                <h4 className="mb-3">{item.title}</h4>
                {item?.products?.map((_item) => (
                  <Card className="card-bordered" key={_item.id}>
                    <CardBody>
                      <Row className="align-items-center">
                        <Col size="12" sm="6" md="4" lg="4" className="my-2">
                          <h6>{_item.title}</h6>
                          <hr className="hr border-light" />
                          <div className="text-justify text-muted">
                            {_item?.category?.title}
                          </div>
                        </Col>
                        <Col
                          size="12"
                          sm="6"
                          md="4"
                          lg="5"
                          className="my-2 border-right border-left"
                        >
                          <div className="text-justify text-muted">
                            {_item.description}
                          </div>
                        </Col>
                        <Col
                          size="12"
                          md="4"
                          lg="3"
                          className="my-2 text-center"
                        >
                          {_item?.price ? (
                            <div className="d-flex align-items-center justify-content-center mb-4">
                              <div className="fa-2x">
                                <ConvertCurrency price={_item?.price} />
                              </div>
                              <div className="mx-1">
                                <Currency />
                              </div>
                            </div>
                          ) : (
                            <Badge color="info">
                              {receptionInfo.isAgentConfirm
                                ? "نیازمند تایید نماینده"
                                : "نیازمند تایید پذیرنده"}
                            </Badge>
                          )}
                          <div className="mt-4">
                            <Button
                              color="primary"
                              size="lg"
                              onClick={() =>
                                setValue("products", [{ ..._item, count: 1 }])
                              }
                            >
                              انتخاب محصول
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <div
                        className="cursor-pointer"
                        onClick={() => setIsShowFeatures(!isShowFeatures)}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h6>امکانات</h6>
                          <span>
                            <p className="text-center font-weight-bold text-dark">
                              {isShowFeatures ? "بستن" : "+ امکانات بیشتر"}
                            </p>
                          </span>
                        </div>
                        <ul className="row">
                          {_item?.features
                            ?.filter((_, index) =>
                              isShowFeatures ? index >= 0 : index < 4
                            )
                            ?.map((item, index) => (
                              <li
                                key={index}
                                className="col-6 col-sm-4 col-md-3 my-1"
                              >
                                <div className="fs-14px fw-bold text-muted">
                                  {item}
                                </div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </CardFooter>
                  </Card>
                ))}
              </Fragment>
            ))}
          </>
        )}
      </Block>

      <Modal
        isOpen={isShowAddress}
        className="modal-dialog-centered"
        size="md"
        toggle={() => setIsShowAddress(false)}
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => setIsShowAddress(false)}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h6 className="title">آدرس پذیرنده</h6>
            <br />
            <OLMap
              className="rounded border p-1"
              latitude={receptionInfo?.geo?.latitude}
              longitude={receptionInfo?.geo?.longitude}
              style={{ width: "auto", height: "400px" }}
            />
          </div>

          <p className="fs-14px fw-bold text-muted ml-3">
            {receptionInfo.address}
          </p>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={!isEmpty(watch("products"))}
        className="modal-dialog-centered"
        size="md"
        toggle={() => reset()}
      >
        <ModalBody>
          <span type="button" onClick={() => reset()} className="close">
            <Icon name="cross-sm" />
          </span>
          <form
            onSubmit={handleSubmit((data) =>
              areYouSureMessage(
                () => handleCreateOrder(data),
                "آیا از ثبت سفارش اطمینان دارید؟"
              )
            )}
            className="is-alter p-2"
          >
            <h5 className="title">سبد خرید</h5>
            <br />

            <Col size="12">
              <div className="data-head my-3">
                <div className="form-control-wrap">
                  <input type="hidden" className="form-control" />
                  <ErrorMessage message={errors.products?.message} />
                </div>
                <h6 className="overline-title">محصولات</h6>
              </div>
              {isEmpty(watch("products")) ? (
                <div className="text-center alert alert-info">
                  <span className="text-silent">
                    محصولی برای نمایش یافت نشد
                  </span>
                </div>
              ) : (
                <Row className="gy-4">
                  {watch("products")?.map((item, index) => (
                    <Col size="12" key={index}>
                      <Card>
                        <CardHeader>
                          <div className="d-flex justify-content-between align-items-center">
                            <h4 className="m-0">{item.title}</h4>
                            <div>
                              {item.price ? (
                                <>
                                  <ConvertCurrency price={item.price} />{" "}
                                  <Currency />
                                </>
                              ) : (
                                "اعتباری"
                              )}
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody>
                          <InputGroup>
                            <div className="input-group-prepend">
                              <Button
                                type="button"
                                color="primary"
                                onClick={() => {
                                  setValue(
                                    `products[${index}].count`,
                                    item.count + 1
                                  );
                                  setReduce(item.count + 1);
                                }}
                              >
                                +
                              </Button>
                            </div>
                            <input
                              type="number"
                              placeholder="تعداد را وارد نمایید"
                              className="form-control-lg form-control"
                              disabled
                              readOnly
                              {...register(`products[${index}].count`)}
                            />
                            <div className="input-group-append">
                              <Button
                                type="button"
                                color="danger"
                                onClick={() => {
                                  setValue(
                                    `products[${index}].count`,
                                    item.count - 1
                                  );
                                  setReduce(item.count - 1);
                                }}
                                disabled={item.count <= 1}
                              >
                                -
                              </Button>
                            </div>
                            <ErrorMessage
                              message={
                                errors.products &&
                                errors.products[index]?.count?.message
                              }
                            />
                          </InputGroup>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                  {receptionInfo.type === categoryItems[0] && (
                    <Col size="12">
                      <FormGroup>
                        <div className="data-head my-3">
                          <h6 className="overline-title">تاریخ ورود و خروج</h6>
                        </div>
                        <Row className="gy-4">
                          <Col size="12">
                            <div className="form-control-wrap">
                              <RangeDateTimePicker
                                initValue={{
                                  from: watch("from"),
                                  to: watch("to"),
                                }}
                                onChange={(e) => {
                                  setValue("from", e.from);
                                  setValue("to", e.to);
                                }}
                                placeholder="تاریخ ورود تا تاریخ خروج"
                                className="form-control form-control-lg py-4"
                              />
                              <ErrorMessage message={errors.from?.message} />
                              <ErrorMessage message={errors.to?.message} />
                            </div>
                          </Col>
                          <Col size="12">
                            <div className="data-head my-3">
                              <div className="form-control-wrap">
                                <input type="hidden" className="form-control" />
                                <ErrorMessage
                                  message={errors.guests?.message}
                                />
                              </div>
                              <h6 className="overline-title">
                                اطلاعات مسافران
                              </h6>
                            </div>
                            <Button
                              outline
                              type="button"
                              onClick={() => handleAddItem("guests")}
                              color="primary"
                              className="mb-2"
                            >
                              <Icon name="plus" className="mr-3" /> افزودن
                            </Button>
                            {isEmpty(watch("guests")) ? (
                              <div className="text-center alert alert-info">
                                <span className="text-silent">
                                  مسافری برای نمایش یافت نشد
                                </span>
                              </div>
                            ) : (
                              <Row className="gy-4">
                                {watch("guests")?.map((_, index) => (
                                  <Col size="12" key={index}>
                                    <InputGroup>
                                      <input
                                        type="text"
                                        placeholder="نام مسافر را وارد نمایید"
                                        className="form-control-lg form-control"
                                        {...register(
                                          `guests[${index}].first_name`
                                        )}
                                      />
                                      <input
                                        type="text"
                                        placeholder="نام خانوادگی مسافر را وارد نمایید"
                                        className="form-control-lg form-control"
                                        {...register(
                                          `guests[${index}].last_name`
                                        )}
                                      />
                                      <Button
                                        color="icon"
                                        type="button"
                                        className="btn-trigger text-danger"
                                        onClick={() =>
                                          handleRemoveItem("guests", index)
                                        }
                                      >
                                        <Icon name="trash" />
                                      </Button>
                                      {errors.guests && (
                                        <>
                                          <ErrorMessage
                                            message={
                                              errors.guests[index]?.first_name
                                                ?.message
                                            }
                                          />
                                          <ErrorMessage
                                            message={
                                              errors.guests[index]?.last_name
                                                ?.message
                                            }
                                          />
                                        </>
                                      )}
                                    </InputGroup>
                                  </Col>
                                ))}
                              </Row>
                            )}
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                  )}
                  <Col size="12">
                    <FormGroup>
                      <div className="data-head my-3">
                        <h6 className="overline-title">توضیحات</h6>
                      </div>
                      <div className="form-control-wrap">
                        <textarea
                          placeholder="توضیحات را وارد نمایید"
                          className="form-control-lg form-control"
                          {...register("description")}
                          rows={7}
                        />
                        <ErrorMessage message={errors.description?.message} />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </Col>
            <br />

            <table className="table table-striped">
              <tfoot>
                <tr>
                  <td></td>
                  <td>مبلغ قابل پرداخت</td>
                  <td>
                    <ConvertCurrency
                      price={watch("products")?.reduce(
                        (prev, current) =>
                          (prev += +current?.count * +current?.price),
                        0
                      )}
                    />{" "}
                    <Currency />
                  </td>
                </tr>
              </tfoot>
            </table>
            <br />
            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
              <li>
                <Button color="primary" size="lg" type="submit">
                  تکمیل سفارش
                </Button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => reset()}
                  className="link link-light"
                >
                  انصراف
                </button>
              </li>
            </ul>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ReceptionInfoUser;
